export default {
    current: state =>  state.current
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/checkin/getters.js
// module id = null
// module chunks = 